import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, Button, CircularProgress, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { FormEvent, useState } from "react";

interface PasswordLoginProps {
  email: string;
  password: string;
  loading: boolean;
  onEmailChange: (email: string) => void;
  onPasswordChange: (password: string) => void;
  onSubmit: (e: FormEvent) => void;
  onSwitchToCode: () => void;
  onForgotPassword: () => void;
  formClassName: string;
  switchModeClassName: string;
}

const PasswordLogin = ({
  email,
  password,
  loading,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onSwitchToCode,
  onForgotPassword,
  formClassName,
  switchModeClassName
}: PasswordLoginProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <form className={formClassName} onSubmit={onSubmit}>
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          required
          fullWidth
          variant="outlined"
        />
        <TextField
          label="Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          required
          fullWidth
          variant="outlined"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          disabled={loading}
          sx={{ mt: 1 }}
        >
          {loading ? (
            <><CircularProgress size={20} sx={{ mr: 1 }} />Signing in...</>
          ) : (
            <>Sign In</>
          )}
        </Button>
      </form>
      
      <Box textAlign="center" mt={2}>
        <Typography 
          variant="body2" 
          className={switchModeClassName}
          onClick={onSwitchToCode}
          sx={{ mb: 1 }}
        >
          Don't have a password? Login with code instead
        </Typography>
        <Typography 
          variant="body2" 
          className={switchModeClassName}
          onClick={onForgotPassword}
          sx={{ mb: 2 }}
        >
          Forgot your password?
        </Typography>
      </Box>
    </>
  );
};

export default PasswordLogin;